module.exports = __webpack_public_path__ + "static/generoLogo-42c1675eb463ff6f0b932b7ffe73686e.png";